import React from "react";
import VisionMissionImage from "@img/visimisi/visimisi.png";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

const VisiMisi = () => {
  const [visionMission, setVisionMission] = useState([]);

  useEffect(() => {
    fetchVisionMission();
  }, []);

  const fetchVisionMission = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/vision-missions"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data visi misi");
      }
      const data = await response.json();
      setVisionMission(data.data[0] || []);
    } catch (error) {
      setVisionMission([]);
    }
  };

  return (
    <>
      <div className="w-full flex justify-center mobile:mt-24">
        <img
          src={`${process.env.REACT_APP_API_URL}/${visionMission.image}`}
          className="relative object-cover block w-full h-auto lg:w-screen lg:h-[40rem]"
          alt="header"
        />
      </div>
      <div className="mt-10 flex justify-center items-center">
        <img src={VisionMissionImage} className="max-w-[80%] h-auto" alt="Sejarah" />
      </div>
      <div className="w-7/12 mt-10 py-10 mx-auto grid mobile:grid-rows-1">
        <h1 className="font-extrabold text-3xl text-center">
          {visionMission.title}
        </h1>
        <div
          className="mt-8 text-center"
          dangerouslySetInnerHTML={{ __html: visionMission.description }}
        />
      </div>
      {/* Visi */}
      <div className="w-7/12 mt-10 mx-auto grid mobile:grid-rows-1">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-[#e01f31]">Visi</h1>
          <div
            className="text-xl mt-4 italic"
            dangerouslySetInnerHTML={{ __html: visionMission.vision }}
          />
        </div>
      </div>

      {/* Misi */}
      <div className="w-7/12 py-10 mx-auto grid mobile:grid-rows-1">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-[#1c75ac] mb-8">Misi</h1>
          <div className="grid gap-8 sm:grid-cols-1 lg:grid-cols-3 justify-items-center">
            {visionMission.mission &&
              visionMission.mission
                .split("<p>")
                .filter(
                  (mission) =>
                    mission.trim() !== "" &&
                    mission !== "<br>" &&
                    mission !== "</p>"
                )
                .map((mission, index) => (
                  <div
                    key={index}
                    className="bg-white p-4 flex flex-col items-center"
                  >
                    <span className="text-6xl font-bold text-[#1c75ac] rounded-full border-4 border-[#1c75ac] w-16 h-16 flex items-center justify-center">
                      {index + 1}
                    </span>
                    <p
                      className="text-lg mt-6 text-center"
                      dangerouslySetInnerHTML={{
                        __html: mission.replace("</p>", ""),
                      }}
                    />
                  </div>
                ))}
          </div>
        </div>
      </div>
      <FloatingMenu />
    </>
  );
};

export default VisiMisi;
